import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatTableModule } from '@angular/material/table';
import { TranslateModule } from '@ngx-translate/core';
import { WaybillEquipmentMaterialItemModel } from '../../../store/models/waybill-equipments.model';
import { MeasurementUnitCodesEnum } from '../../../common/models';
import { MeasurementUnitCodesMap } from '../../../common/constants';
import { PipesModule } from '../../../common/pipes/pipes.module';
import { DirectivesModule } from '../../../common/directives/directives.module';

@Component({
    selector: 'ui-equipment-materials',
    imports: [CommonModule, TranslateModule, PipesModule, DirectivesModule, MatCardModule, MatTableModule],
    templateUrl: './equipment-materials.component.html',
    styleUrls: ['./equipment-materials.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class EquipmentMaterialsComponent {
  @Input() materials: WaybillEquipmentMaterialItemModel[] = [];
  @Input() volumeUnitCode: MeasurementUnitCodesEnum | null = null;
  @Input() weightUnitCode: MeasurementUnitCodesEnum | null = null;
  materialColumns: string[] = [
    'materialNumber',
    'materialDescription',
    'grossWeight',
    'netWeight',
    'volume',
    'quantity',
    'quantityUnitCode',
  ];
  protected readonly measurementUnitCodes = MeasurementUnitCodesMap;
}
